import { render, staticRenderFns } from "./NeoparentConsentDenied.vue?vue&type=template&id=727758ae&scoped=true"
import script from "./NeoparentConsentDenied.vue?vue&type=script&lang=js"
export * from "./NeoparentConsentDenied.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727758ae",
  null
  
)

export default component.exports